const axios = require('axios')

/**
 * AxiosApi class
 */
module.exports = class AxiosApi {
    /**
     * AxiosApi class constructor
     */
    constructor(request, response, env, apiDomain) {
        this.request = request
        this.response = response
        this.env = env

        let headerCollection, headers, authHeader, jsonHeaders = this.constructor.getJSONHeaders()

        headers = this.request.headers

        authHeader = {
            "Authorization": `Bearer ${this.env.AUTH_SERVER_AUTHORIZATION_KEY}`
        }

        headerCollection = { ...headers, ...authHeader, ...jsonHeaders, }

        delete headerCollection["host"]

        this.axiosInstance = axios.create({
            baseURL: apiDomain,
            timeout: 10000,
            headers: headerCollection
        })
    }

    /**
     * Static JSON headers for external fetch() requests
     */
    static getJSONHeaders() {
        return {
            "Content-Type": "application/json",
            "accept": "application/json"
        }
    }

    /**
     * Method to handle response from fetch()
     * @param {} response Response object
     */
    static handleResponse(response) {
        if (response.status === 200) {
            return response.data
        }

        throw Error(response.statusText)
    }

    async postData() {
        let _response, post, action

        post = this.request.body
        action = this.request.query.action

        _response = await this.axiosInstance.post(`/contact/contact-api/?action=${action}`, post)
            .then((response) => this.constructor.handleResponse(response))
            .catch(function(error) {
                console.log(`Error in Contact Api postData function: ${error}`)
            })

        if (typeof _response === "object") {
            
            if (_response.code === 404) {
                console.log(`Error 404\n`)
                return false;
            }

            if (_response.code === 500) {
                console.log(`Error 500\n`)
                return false;
            }

            if (_response.code === 200) {
                return {
                    data: _response.data,
                    code: _response.code
                }
            }
        }

        return _response
    }

    async postCheckEmail(email) {
        let _response, post, action

        post = email
        _response = await this.axiosInstance.post(`/contact/api`,
            `
            {
                contact(email:"${post}")
                {
                    id
                    email
                }
            }`)
            .then((response) => this.constructor.handleResponse(response))
            .catch(function(error) {
                console.log(`Error in Contact Api postData function: ${error}`)
            })

        if (typeof _response === "object") {
            
            if (_response.code === 404) {
                console.log(`Error 404\n`)
                return false;
            }

            if (_response.code === 500) {
                console.log(`Error 500\n`)
                return false;
            }

            if (_response.code === 200) {
                return {
                    data: _response.data,
                    code: _response.code
                }
            }
        }

        return _response
    }

}